import type { ComponentProps, ReactNode } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/Unistyles/Box';

type FieldCardProps = Omit<
  ComponentProps<typeof Box>,
  'children' | 'p' | 'space' | 'style'
> & {
  children: ReactNode;
};

export default function FieldCard({ children, ...boxProps }: FieldCardProps) {
  return (
    <Box {...boxProps} p="lg" space="md" style={styles.card}>
      {children}
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  card: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.borderMuted,
    borderCurve: 'continuous',
    borderRadius: theme.borderRadius.xl,
    borderWidth: theme.size(0.5),
    width: '100%',
  },
}));
